import axiosHandler from "interceptor/axiosInterceptor";

export const getRoleAccess = async (roleAccessId) => {
  try {
    const response = await axiosHandler.get("/roleAccess/get-by-role", {
      params: { roleId: roleAccessId },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateRoleAccess = async (data, roleAccessId) => {
  try {
    const response = await axiosHandler.put(
      `/roleAccess/edit/${roleAccessId}`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};
